import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Typography, Drawer, Button } from "antd";
import {
  HomeOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  UploadOutlined,
  ClockCircleOutlined,
  LoginOutlined,
  ScanOutlined,
  SafetyOutlined,
  BankOutlined,
  SolutionOutlined,
  ApartmentOutlined,
  FormOutlined,
  FileProtectOutlined,
  DollarOutlined,
  FileTextOutlined,
  CalendarOutlined,
  FileDoneOutlined,
  ProfileOutlined,
  ScheduleOutlined,
  LogoutOutlined,
  UserDeleteOutlined,
  AuditOutlined,
  EnvironmentOutlined,
  CalendarTwoTone,
  BarChartOutlined,
  FileExcelOutlined,
  PieChartOutlined,
  RiseOutlined,
  PlusSquareOutlined,
  ThunderboltOutlined,
  ReadOutlined,
  MenuOutlined,
  ExportOutlined,
  AlertOutlined,
  CheckSquareOutlined
} from "@ant-design/icons";
import DashboardHeader from "../../../components/dashboardheader/DashboardHeader";
import Footer from "../../../components/footer/Footer";
import { AuthContext } from "../../../context/AuthContext";
import HrArea from "../../announcement/hrarea/HrArea";
import HrVerifiedCandidates from "../HrVerifiedCandidates";
import AddHoliday from "../AddHoliday";
import ViewHoliday from "../ViewHoliday";
import ViewEmployees from "../../ViewEmployees";
import HrViewAnnouncement from "../../hr/hrviewannouncement/HrViewAnnouncement";
import SalaryStatement from "../../../components/payroll/SalaryStatement";
import ActualSalaryStatement from "../ActualSalaryStatement";
import FinalSalaryStatement from "../FinalSalaryStatement";
import AddAppraisal from "../AddAppraisal";
import TriggerAppraisal from "../TriggerAppraisal";
import ShowOneAssessment from "../../ShowOneAssessment";
import TeamAssessment from "../../TeamAssessment";
import FinalSettlement from "../FinalSettlement";
import HrIndex from "../../hr/HrIndex";
import EmployeeAttendanceReport from "../../../components/HrReports/EmployeeAttendanceReport";
import LeaveUtilizationReport from "../../../components/HrReports/LeaveUtilizationReport";
import FullSettlement from "../FullSettlement";
import FixedSalary from "../../hr/FixedSalary";
import BulkEmpUpload from "../BulkEmpUpload";
import OtApprovals from "../../../components/OtApprovals";
import ViewMrfPage from "../../onboarding/viewmrfpage/ViewMrfPage";
import InterviewAssessment from "../../onboarding/interview/InterviewAssessment";
import AddVenue from "../../onboarding/AddVenue";
import SignatureUpdation from "../SignatureUpdation";
import MakeSpecialPermission from "../../MakeSpecialPermission";
import SendMail from "../../../components/SendMail";
import NewEmployees from "../../NewEmployees";
import ViewEmployeeAttendance from "../../hr/ViewEmployeeAttendance";
import FingerHeadOffice from "../../hr/FingerPrintHead";
import AttendanceHead from "../../hr/AttendanceHead";
import FingerPrintSite from "../../hr/FingerPrintSite";
import AttendanceSite from "../../hr/AttendanceSite";
import OverallOT from "../../../components/hr/OverallOT";
import ShowSpecialPermission from "../../ShowSpecialPermission";
import PermissionRequests from "../../hr/PermissionRequests";
import TechnicalIssue from "../TechincalIssue";
import EmpLeaves from "../../hr/EmpLeaves";
import EmpPermissions from "../../hr/EmpPermissions";
import EmpCompoff from "../../hr/EmpCompoff";
import MyStatusRequests from "../MyStatusRequests";
import ImproperAttendance from "../ImproperAttendance";
import ViewImproper from "../ViewImproper";
import PastOnduty from "../../employee/PastOnduty";
import QuickView from "../QuickView";
import AddCompoff from "../AddCompoff";
import MasterCreation from "../MasterCreation";
import AddDepartments from "../AddDepartments";
import AddDesignations from "../AddDesignation";
import AddOrganisations from "../AddOrganisations";
import ChangeHod from "../ChangeHod";
import ActiveEmployees from "../ActiveEmployees";
import InactiveEmployees from "../InactiveEmployees";
import HodChange from "../../hr/HodChange";
import GetStatusChange from "../../hr/GetStatusChange";


const { Sider, Content } = Layout;
const { Title } = Typography;

// Map each leaf key to its parent key(s) for active parent detection
const keyParentMap = {
  showCandidates: ["employee"],
  viewEmployees: ["employee"],
  empbulkupload: ["employee"],
  viewEmployeeRecords: ["attendance"],
  fingerHeadOffice: ["attendance"],
  attendanceHeadOffice: ["attendance"],
  fingerSiteOffice: ["attendance"],
  attendanceSiteOffice: ["attendance"],
  otapproval: ["attendance"],
  special_permission: ["attendance", "generalpermission"],
  show_special_permission: ["attendance", "generalpermission"],
  raise_technical_issue: ["attendance", "generalpermission"],
  improper: ["attendance", "improperAttendance"],
  viewImproper: ["attendance", "improperAttendance"],
  viewsalary: ["payroll"],
  actualsalary: ["payroll"],
  Finalsalary: ["payroll"],
  empleaves: ["leaves"],
  emppermissions: ["leaves"],
  empcompoffs: ["leaves"],
  job_openings: ["requirtment"],
  interview: ["requirtment"],
  resignedEmployees: ["Exit Management"],
  fullsettlement: ["Exit Management"],
  addHolidays: ["holidays"],
  editHolidays: ["holidays"],
  employeeattendance: ["reports"],
  leaveutilization: ["reports"],
  addAppraisal: ["appraisal"],
  startAppraisal: ["appraisal"],
  viewAppraisals: ["appraisal"],
};

export default function PayrollHr() {
  const { authData } = useContext(AuthContext);

  const [selectedMenu, setSelectedMenu] = useState(() => {
    return localStorage.getItem("payrollHrPage") || "home";
  });

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    localStorage.setItem("payrollHrPage", selectedMenu);
  }, [selectedMenu]);

  // Get all active parent keys for current selection
  const activeParentKeys = keyParentMap[selectedMenu] || [];

  const menuItems = [
    { key: "home", icon: <HomeOutlined />, label: "Dashboard" },
    {
      key: "employee",
      icon: <UsergroupAddOutlined />,
      label: "Employee Management",
      children: [
        { key: "showCandidates", icon: <UserSwitchOutlined />, label: "Convert Employee" },
        { key: "viewEmployees", icon: <TeamOutlined />, label: "View Employees" },
        { key: "quickView", icon: <TeamOutlined />, label: "Quick View" },
        { key: "empbulkupload", icon: <UploadOutlined />, label: "Employee Bulk Upload" },
        ...(authData?.employee?.role === 2 || authData?.employee?.role_id === 2 || authData?.employee?.is_hr
          ? [
              {
                key: "replaceHod",
                icon: <UserSwitchOutlined />,
                label: "Replace Hod",
                children: [
                  { key: "changeHod", icon: <UserSwitchOutlined />, label: "Change Hod" },
                  { key: "ViewHodReport", icon: <UserSwitchOutlined />, label: "View Approvals" },
                ],
              },
            ]
          : []),
        { key: "activeEmployees", icon: <UserSwitchOutlined />, label: "Active Employees" },
        { key: "inactiveEmployees", icon: <UserSwitchOutlined />, label: "Inactive Employees" },
      ],
    },
    (authData?.employee?.role === 2 || authData?.employee?.role_id === 2 || authData?.employee?.is_hr) && {
      key: "onduty",
      icon: <CheckSquareOutlined />,
      label: "Onduty Requests",
    },
    {
      key: "attendance",
      icon: <ClockCircleOutlined />,
      label: "Attendance",
      children: [
        { key: "viewEmployeeRecords", icon: <LoginOutlined />, label: "Check-In & Check-Out" },
        { key: "fingerHeadOffice", icon: <ScanOutlined />, label: "Fingerprint – Head Office" },
        { key: "attendanceHeadOffice", icon: <BankOutlined />, label: "Attendance – Head Office" },
        { key: "fingerSiteOffice", icon: <SafetyOutlined />, label: "Fingerprint – Site Office" },
        { key: "attendanceSiteOffice", icon: <HomeOutlined />, label: "Attendance – Site Office" },
        { key: "otapproval", icon: <SolutionOutlined />, label: "OT Approvals" },
        {
          key: "generalpermission",
          icon: <ApartmentOutlined />,
          label: "General Permission",
          children: [
            { key: "special_permission", icon: <FormOutlined />, label: "Add General Permission" },
            { key: "show_special_permission", icon: <FormOutlined />, label: "Show General Permission" },
            { key: "raise_technical_issue", icon: <FormOutlined />, label: "Raise Technical Issue" },
          ],
        },
        {
          key: "improperAttendance",
          icon: <SolutionOutlined />,
          label: "Improper Attendance",
          children: [
            { key: "improper", icon: <FormOutlined />, label: "Add Improper Attendance" },
            { key: "viewImproper", icon: <FormOutlined />, label: "View Improper Attendance" },
          ],
        },
        { key: "addCompoff", icon: <SolutionOutlined />, label: "Add Compoff" },
      ],
    },
    (authData?.employee?.role === 2 || authData?.employee?.role_id === 2 || authData?.employee?.is_hr) && {
      key: "payroll",
      icon: <DollarOutlined />,
      label: "Payroll",
      children: [
        { key: "viewsalary", icon: <FileTextOutlined />, label: "Actual Salary" },
        { key: "actualsalary", icon: <CalendarOutlined />, label: "Monthly Salary Statement" },
        { key: "Finalsalary", icon: <FileDoneOutlined />, label: "Final Salary Statement" },
      ],
    },
    {
      key: "leaves",
      icon: <CalendarOutlined />,
      label: "Leaves & Permissions",
      children: [
        { key: "empleaves", icon: <FileDoneOutlined />, label: "Leaves" },
        { key: "emppermissions", icon: <ExportOutlined />, label: "Permissions" },
        { key: "empcompoffs", icon: <AlertOutlined />, label: "Off Day Working" },
      ],
    },
    {
      key: "requirtment",
      icon: <ProfileOutlined />,
      label: "Recruitment",
      children: [
        { key: "job_openings", icon: <FileTextOutlined />, label: "Job Openings" },
        { key: "interview", icon: <ScheduleOutlined />, label: "Schedule Interview" },
      ],
    },
    {
      key: "Exit Management",
      icon: <LogoutOutlined />,
      label: "Exit Management",
      children: [
        { key: "resignedEmployees", icon: <UserDeleteOutlined />, label: "Resigned Employees" },
        { key: "fullsettlement", icon: <AuditOutlined />, label: "Full & Final Settlement" },
      ],
    },
    // { key: "addVenue", icon: <EnvironmentOutlined />, label: "Add Venue" },
    {
      key: "holidays",
      icon: <CalendarTwoTone />,
      label: "Holiday List",
      children: [
        { key: "addHolidays", icon: <PlusSquareOutlined />, label: "Add Holidays" },
        { key: "editHolidays", icon: <ReadOutlined />, label: "View Holidays" },
      ],
    },
    {
      key: "reports",
      icon: <BarChartOutlined />,
      label: "Reports",
      children: [
        { key: "employeeattendance", icon: <FileExcelOutlined />, label: "Employee Attendance Report" },
        { key: "leaveutilization", icon: <PieChartOutlined />, label: "Leave Utilization Report" },
      ],
    },
    {
      key: "appraisal",
      icon: <RiseOutlined />,
      label: "Appraisal",
      children: [
        { key: "addAppraisal", icon: <PlusSquareOutlined />, label: "Add Appraisal" },
        { key: "startAppraisal", icon: <ThunderboltOutlined />, label: "Trigger Appraisal" },
        { key: "viewAppraisals", icon: <ReadOutlined />, label: "View Appraisal Assessments" },
      ],
    },
    { key: "statusApprovals", icon: <FormOutlined />, label: "Status Requests" },
    ...(authData?.employee?.role === 2 || authData?.employee?.role_id === 2 || authData?.employee?.is_superuser || authData?.employee?.is_hr
      ? [
          { key: "changeEmpStatus", icon: <FormOutlined />, label: "Employee Status Change" }
        ]
      : []),
    {
      key: "masterCreation", icon: <FormOutlined />, label: "Master Creation",
      children: [
        { key: "addOrganisations", icon: <ReadOutlined />, label: "Add Organisations" },
        { key: "addDepartments", icon: <PlusSquareOutlined />, label: "Add Departments" },
        { key: "addDesignations", icon: <ThunderboltOutlined />, label: "Add Designations" },
        { key: "addVenues", icon: <EnvironmentOutlined />, label: "Add Venues" },
      ],
    },
  ];

  const menuStyles = `
    /* ── Base menu reset ── */
    .payroll-menu.ant-menu {
      background: #fff !important;
      border-right: none !important;
    }

    /* ── All items default ── */
    .payroll-menu .ant-menu-item,
    .payroll-menu .ant-menu-submenu-title {
      font-weight: 600;
      font-size: 13px;
      color: #4a5568 !important;
      border-radius: 6px !important;
      margin: 2px 8px !important;
      width: calc(100% - 16px) !important;
      transition: all 0.2s ease;
    }

    /* ── Hover state ── */
    .payroll-menu .ant-menu-item:hover,
    .payroll-menu .ant-menu-submenu-title:hover {
      background-color: #e8f0fe !important;
      color: #0e497b !important;
    }
    .payroll-menu .ant-menu-item:hover .anticon,
    .payroll-menu .ant-menu-submenu-title:hover .anticon {
      color: #0e497b !important;
    }

    /* ── Selected leaf item ── */
    .payroll-menu .ant-menu-item-selected {
      background-color: #0e497b !important;
      color: #ffffff !important;
      box-shadow: 0 2px 8px rgba(14, 73, 123, 0.35) !important;
    }
    .payroll-menu .ant-menu-item-selected .anticon {
      color: #ffffff !important;
    }
    .payroll-menu .ant-menu-item-selected::after {
      display: none !important;
    }

    /* ── Active parent submenu title (has selected child) ── */
    .payroll-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {
      background-color: #0e497b !important;
      color: #ffffff !important;
      box-shadow: 0 2px 8px rgba(14, 73, 123, 0.3) !important;
      border-radius: 6px !important;
    }
    .payroll-menu .ant-menu-submenu-selected > .ant-menu-submenu-title .anticon {
      color: #ffffff !important;
    }
    .payroll-menu .ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
    .payroll-menu .ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
      background-color: #ffffff !important;
    }

    /* ── Open (expanded) submenu title – not necessarily selected ── */
    .payroll-menu .ant-menu-submenu-open:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title {
      background-color: #1a6ab5 !important;
      color: #ffffff !important;
      border-radius: 6px !important;
    }
    .payroll-menu .ant-menu-submenu-open:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title .anticon {
      color: #ffffff !important;
    }
    .payroll-menu .ant-menu-submenu-open:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
    .payroll-menu .ant-menu-submenu-open:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
      background-color: #ffffff !important;
    }

    /* ── Sub-menu popup / inline background ── */
    .payroll-menu .ant-menu-sub.ant-menu-inline {
      background: #f0f6ff !important;
      border-left: 3px solid #0e497b !important;
      margin-left: 12px !important;
      border-radius: 0 0 6px 6px;
    }

    /* ── Sub-menu items default ── */
    .payroll-menu .ant-menu-sub .ant-menu-item,
    .payroll-menu .ant-menu-sub .ant-menu-submenu-title {
      color: #2d5a8e !important;
      font-weight: 500 !important;
      background: transparent !important;
      margin: 2px 4px !important;
      width: calc(100% - 8px) !important;
      padding-left: 24px !important;
    }

    /* ── Sub-menu item hover ── */
    .payroll-menu .ant-menu-sub .ant-menu-item:hover,
    .payroll-menu .ant-menu-sub .ant-menu-submenu-title:hover {
      background-color: #c7ddf7 !important;
      color: #0e497b !important;
    }

    /* ── Sub-menu selected item ── */
    .payroll-menu .ant-menu-sub .ant-menu-item-selected {
      background-color: #f59e0b !important;
      color: #1a1a1a !important;
      font-weight: 700 !important;
      box-shadow: 0 2px 6px rgba(245, 158, 11, 0.4) !important;
    }
    .payroll-menu .ant-menu-sub .ant-menu-item-selected .anticon {
      color: #1a1a1a !important;
    }

    /* ── Nested level 3 sub-menu ── */
    .payroll-menu .ant-menu-sub .ant-menu-sub.ant-menu-inline {
      background: #dbeafe !important;
      border-left: 3px solid #f59e0b !important;
      margin-left: 8px !important;
    }
    .payroll-menu .ant-menu-sub .ant-menu-sub .ant-menu-item {
      padding-left: 32px !important;
      color: #1e3a5f !important;
    }
    .payroll-menu .ant-menu-sub .ant-menu-sub .ant-menu-item-selected {
      background-color: #f59e0b !important;
      color: #1a1a1a !important;
    }

    /* ── Arrow color default ── */
    .payroll-menu .ant-menu-submenu-arrow::before,
    .payroll-menu .ant-menu-submenu-arrow::after {
      background-color: #4a5568 !important;
    }
    .payroll-menu .ant-menu-submenu:hover > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
    .payroll-menu .ant-menu-submenu:hover > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
      background-color: #0e497b !important;
    }

    /* ── Scrollbar styling ── */
    .payroll-sider .ant-layout-sider-children {
      overflow-y: auto;
      overflow-x: hidden;
    }
    .payroll-sider .ant-layout-sider-children::-webkit-scrollbar {
      width: 4px;
    }
    .payroll-sider .ant-layout-sider-children::-webkit-scrollbar-thumb {
      background: #c7ddf7;
      border-radius: 4px;
    }
  `;

  const renderContent = () => {
    switch (selectedMenu) {
      case "home": return <HrIndex />;
      case "makeAnnouncement": return <HrArea />;
      case "viewAnnouncement": return <HrViewAnnouncement />;
      case "showCandidates": return <HrVerifiedCandidates />;
      case "addHolidays": return <AddHoliday />;
      case "editHolidays": return <ViewHoliday />;
      case "viewEmployees": return <ViewEmployees />;
      case "fullsettlement": return <FullSettlement />;
      case "salarydetails": return <SalaryStatement />;
      case "actualsalary": return <ActualSalaryStatement />;
      case "Finalsalary": return <FinalSalaryStatement />;
      case "addAppraisal": return <AddAppraisal />;
      case "startAppraisal": return <TriggerAppraisal />;
      case "viewAppraisals": return <TeamAssessment />;
      case "finalsettlements": return <FinalSettlement />;
      case "employeeattendance": return <EmployeeAttendanceReport />;
      case "leaveutilization": return <LeaveUtilizationReport />;
      case "viewsalary": return <FixedSalary />;
      case "empbulkupload": return <BulkEmpUpload />;
      case "otapproval": return <OtApprovals />;
      case "job_openings": return <ViewMrfPage />;
      case "interview": return <InterviewAssessment />;
      case "addVenues": return <AddVenue />;
      case "signatureUpdation": return <SignatureUpdation />;
      case "special_permission": return <MakeSpecialPermission />;
      case "show_special_permission": return <PermissionRequests />;
      case "sendmail": return <NewEmployees />;
      case "resignedEmployees": return <ViewEmployees isResigned={true} />;
      case "viewEmployeeRecords": return <ViewEmployeeAttendance />;
      case "fingerHeadOffice": return <FingerHeadOffice />;
      case "attendanceHeadOffice": return <AttendanceHead />;
      case "fingerSiteOffice": return <FingerPrintSite />;
      case "attendanceSiteOffice": return <AttendanceSite />;
      case "empot": return <OverallOT />;
      case "raise_technical_issue": return <TechnicalIssue />;
      case "empleaves": return <EmpLeaves />;
      case "emppermissions": return <EmpPermissions />;
      case "empcompoffs": return <EmpCompoff />;
      case "statusApprovals": return <MyStatusRequests />;
      case "changeEmpStatus": return <GetStatusChange />;
      case "improper": return <ImproperAttendance />;
      case "viewImproper": return <ViewImproper />;
      case "onduty": return <PastOnduty />;
      case "quickView": return <QuickView />;
      case "addCompoff": return <AddCompoff />;
      case "masterCreation": return <MasterCreation />;
      case "addDepartments": return <AddDepartments />;
      case "addDesignations": return <AddDesignations />;
      case "addOrganisations": return <AddOrganisations />;
      case "changeHod": return <ChangeHod />;
      case "activeEmployees": return <ActiveEmployees />;
      case "inactiveEmployees": return <InactiveEmployees />;
      case "ViewHodReport": return <HodChange />;
      default: return null;
    }
  };

  const sharedMenu = (onSelect) => (
    <Menu
      mode="inline"
      selectedKeys={[selectedMenu]}
      defaultOpenKeys={activeParentKeys}
      onClick={({ key }) => {
        setSelectedMenu(key);
        if (onSelect) onSelect();
      }}
      className="payroll-menu"
      style={{
        height: "100%",
        borderRight: 0,
        background: "#fff",
      }}
      items={menuItems.filter(Boolean)}
    />
  );

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <style>{menuStyles}</style>
      <DashboardHeader />

      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}

      <Layout style={{ background: "#fff" }}>
        {/* DESKTOP SIDEBAR */}
        {!isMobile && (
          <Sider
            className="payroll-sider"
            width={280}
            collapsible
            collapsed={collapsed}
            onCollapse={(val) => setCollapsed(val)}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #f0f0f0",
              boxShadow: "2px 0 8px rgba(0,0,0,0.06)",
            }}
          >
            {sharedMenu(null)}
          </Sider>
        )}

        {/* MOBILE DRAWER */}
        <Drawer
          title="Menu"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
          footer={null}
        >
          {sharedMenu(() => setDrawerVisible(false))}
        </Drawer>

        {/* MAIN CONTENT */}
        <Layout style={{ padding: isMobile ? "10px" : "24px", background: "#fff" }}>
          <Content style={{ background: "#fff" }}>{renderContent()}</Content>
        </Layout>
      </Layout>

      <Footer style={{ background: "#fff" }} />
    </Layout>
  );
}